module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    attrs: {
      "visible": _vm.drawerVisible,
      "size": "65%",
      "with-header": false,
      "custom-class": "sales-trend-drawer",
      "destroy-on-close": true,
      "wrapperClosable": false
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "sales-trend-container"
  }, [_c('div', {
    staticClass: "drawer-close-btn",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "hover"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function() {
        return [_c('el-button', {
          staticClass: "rule-btn",
          staticStyle: {
            "margin-right": "12px",
            "background-color": "#409EFF",
            "color": "white",
            "border": "none"
          },
          attrs: {
            "icon": "el-icon-info",
            "circle": "",
            "aria-label": "规则说明"
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "rule-content",
    staticStyle: {
      "padding": "10px",
      "overflow-y": "auto"
    }
  }, [_c('strong', [_vm._v("统计规则说明：")]), _vm._v(" "), _c('p', [_vm._v("1. 销售数据仅统计已完成订单，不含退款、取消、审核等订单。")]), _vm._v(" "), _c('p', [_vm._v("2. 数据更新周期为每日凌晨，部分数据可能存在延迟。")]), _vm._v(" "), _c('p', [_vm._v("3. 综合日均销量采用月均法计算：统计所有时间总销量，除以涉及月份数，再除以30天，反映平均每日销售情况。")]), _vm._v(" "), _c('p', [_vm._v("4. 活跃客户数统计最近30天下单客户。")]), _vm._v(" "), _c('p', [_vm._v("5. 热销月份为销量TOP3月份。")])])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#f56c6c",
      "color": "white",
      "border": "none"
    },
    attrs: {
      "icon": "el-icon-close",
      "circle": "",
      "aria-label": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-base-info"
  }, [_c('div', {
    staticClass: "product-image-container"
  }, [_c('el-image', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.productInfo.picture || _vm.defaultImg,
      "fit": "cover",
      "preview-src-list": [_vm.productInfo.picture || _vm.defaultImg]
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('h3', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productInfo.productName || '产品名称'))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('span', {
    staticClass: "meta-label"
  }, [_vm._v("分类：")]), _vm._v(" "), _c('span', {
    staticClass: "meta-value"
  }, [_vm._v(_vm._s(_vm.productInfo.productClassifyName || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('span', {
    staticClass: "meta-label"
  }, [_vm._v("规格：")]), _vm._v(" "), _c('span', {
    staticClass: "meta-value"
  }, [_vm._v(_vm._s(_vm.productInfo.spec))])]), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('span', {
    staticClass: "meta-label"
  }, [_vm._v("价格：")]), _vm._v(" "), _c('span', {
    staticClass: "meta-value"
  }, [_vm._v("¥" + _vm._s(_vm.productInfo.price || '0.00'))])]), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('span', {
    staticClass: "meta-label"
  }, [_vm._v("成本价：")]), _vm._v(" "), _c('span', {
    staticClass: "meta-value"
  }, [_vm._v("¥" + _vm._s(_vm.productInfo.costPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('span', {
    staticClass: "meta-label"
  }, [_vm._v("创建时间：")]), _vm._v(" "), _c('span', {
    staticClass: "meta-value"
  }, [_vm._v(_vm._s(_vm.productInfo.createTime))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-overview-cards-v2"
  }, [_c('div', {
    staticClass: "stat-card sales"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-sold-out"
  }), _vm._v(" "), _c('span', [_vm._v("累计总销量")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_c('count-to', {
    attrs: {
      "end-val": _vm.statsData.totalSales,
      "duration": 1000
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("箱")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("产品历史总销量")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card revenue"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-money"
  }), _vm._v(" "), _c('span', [_vm._v("累计总销售额")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_vm._v("\n          ¥"), _c('count-to', {
    attrs: {
      "end-val": _vm.statsData.totalRevenue,
      "duration": 1000,
      "decimals": 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("产品历史总销售金额")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card count"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-tickets"
  }), _vm._v(" "), _c('span', [_vm._v("累计销售次数")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-value"
  }, [_c('count-to', {
    attrs: {
      "end-val": _vm.statsData.totalSalesCount,
      "duration": 1000
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("次")])], 1), _vm._v(" "), _c('div', {
    ref: "salesCountChart",
    staticClass: "mini-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("产品总销售次数")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card daily"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-data-line"
  }), _vm._v(" "), _c('span', [_vm._v("综合日均销量")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_c('count-to', {
    attrs: {
      "end-val": _vm.statsData.avgDailySales,
      "duration": 1000
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("箱/天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("基于销售天数")])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-stats"
  }, [_c('div', {
    staticClass: "stat-card yoy",
    class: _vm.parseTrend(_vm.statsData.yoy).type
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('span', [_vm._v("年度同比变化")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseTrend(_vm.statsData.yoy).text) + "\n            "), (_vm.parseTrend(_vm.statsData.yoy).value !== 0) ? _c('count-to', {
    attrs: {
      "end-val": _vm.parseTrend(_vm.statsData.yoy).value,
      "duration": 1000
    }
  }) : _vm._e(), _vm._v("%\n            "), _c('i', {
    class: _vm.parseTrend(_vm.statsData.yoy).icon
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("对比去年同期段")])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card hot"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-sunny"
  }), _vm._v(" "), _c('span', [_vm._v("热销月份")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_vm._v("\n          " + _vm._s(_vm.statsData.hotMonths) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("销量TOP3月份")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card clients"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-user-solid"
  }), _vm._v(" "), _c('span', [_vm._v("活跃客户数")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_c('count-to', {
    attrs: {
      "end-val": _vm.statsData.activeClients,
      "duration": 1000
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("人")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("近30天下单客户")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card price"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-price-tag"
  }), _vm._v(" "), _c('span', [_vm._v("平均成交价")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_vm._v("\n          ¥"), _c('count-to', {
    attrs: {
      "end-val": _vm.statsData.avgDealPrice,
      "duration": 1000,
      "decimals": 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("箱/元")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("产品销售平均成交价")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card trend",
    class: _vm.parseTrend(_vm.statsData.trend).type
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-s-marketing"
  }), _vm._v(" "), _c('span', [_vm._v("近期销售趋势")])]), _vm._v(" "), _c('div', {
    staticClass: "card-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseTrend(_vm.statsData.trend).text) + "\n            "), (_vm.parseTrend(_vm.statsData.trend).value !== 0) ? _c('count-to', {
    attrs: {
      "end-val": _vm.parseTrend(_vm.statsData.trend).value,
      "duration": 1000
    }
  }) : _vm._e(), _vm._v("%\n            "), _c('i', {
    class: _vm.parseTrend(_vm.statsData.trend).icon
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("近3个月销售情况变化")])])]), _vm._v(" "), _c('div', {
    staticClass: "data-controls"
  }, [_c('trend-chart-switcher', {
    attrs: {
      "productId": _vm.productId
    }
  })], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "customer-analysis",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "table-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("客户购买分析")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerData,
      "height": "410",
      "border": "",
      "default-sort": {
        prop: 'totalAmount',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "customerName",
      "label": "客户名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseCount",
      "label": "购买次数",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.purchaseCount || 0)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalQuantity",
      "label": "购买总量(箱)",
      "sortable": "",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.totalQuantity || 0)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalAmount",
      "label": "总金额(元)",
      "sortable": "",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("¥" + _vm._s(_vm.formatNumber(scope.row.totalAmount || 0)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "avgPrice",
      "label": "平均成交价(元)",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.avgPrice !== null) ? _c('span', [_vm._v("¥" + _vm._s(_vm.formatNumber(scope.row.avgPrice)))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "percentage",
      "label": "金额占比",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.percentage !== null) ? _c('el-progress', {
          attrs: {
            "percentage": parseFloat(scope.row.percentage.toFixed(2)),
            "color": _vm.getProgressColor,
            "stroke-width": 21,
            "format": _vm.formatProgress,
            "text-inside": ""
          }
        }) : _c('span', [_vm._v("-")])]
      }
    }])
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171867de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/ProductSalesTrend.vue
// module id = 995
// module chunks = 3